import { render, staticRenderFns } from "./AppTableHeaderRow.vue?vue&type=template&id=398f43d0&scoped=true&"
import script from "./AppTableHeaderRow.vue?vue&type=script&lang=ts&"
export * from "./AppTableHeaderRow.vue?vue&type=script&lang=ts&"
import style0 from "./AppTableHeaderRow.vue?vue&type=style&index=0&id=398f43d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f43d0",
  null
  
)

export default component.exports